module.exports = __webpack_public_path__ + "static/img/flush.44a8b44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/common/flush.jpg
// module id = QJ4o
// module chunks = 1